import { render } from "./difference.vue?vue&type=template&id=29fb5275&scoped=true"
import script from "./difference.vue?vue&type=script&lang=js"
export * from "./difference.vue?vue&type=script&lang=js"

import "./difference.vue?vue&type=style&index=0&id=29fb5275&lang=scss&scoped=true"

import exportComponent from "E:\\项目\\经济运行\\econo-eco-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29fb5275"]])

export default __exports__